"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingDataForUnitWarning = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var MissingDataForUnitWarning = function () {
    var _a;
    var _b = (0, core_1.useComponents)(), WarningNotification = _b.WarningNotification, Heading2 = _b.Heading2;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_MISSING_DATA_FOR_UNIT_WARNING, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(WarningNotification, { noMargin: true, "data-testid": "usage-missing-data-for-unit-warning", id: "usage-missing-data-for-unit-warning" },
            react_1.default.createElement(Heading2, null, copy('dataMissingForUnitWarningTitle')),
            react_1.default.createElement(Copy, { copyKey: "dataMissingForUnitWarningBody" }))));
};
exports.MissingDataForUnitWarning = MissingDataForUnitWarning;
